import { Email, LegalDoc, type LegalArticle } from "../components/Legal.jsx";
import type { ProductInfo } from "../lib/product.js";
import { useProduct } from "../lib/useProduct.js";

// 現場力 プライバシーポリシー 初版（2026-09-15）。提供：株式会社アイバックス。
// 2026-10-01（#110、docs/42）：第3条に IP アドレスによる国・地域の判定と確認コード、判定に使う公開データ（DB-IP・Spamhaus・Tor）の出典を足した。
// 2026-10-04（#123 の 2b、docs/48 §3 ★1・§5）：第3条に8号「利用状況の把握」を足した（射場さんの決定 10/3）。記録するのは画面の表示と操作の種類・日時の数だけで、入力した内容は含まない（DB 20261004_0100）。
//   配備した日が 10/4 でなければ、下の updated の改定日をその日に直す
// 2026-10-04（#124 の 3a の続き、docs/50 §7）：第2条5号に「画面の写し」を足した（問い合わせの窓で「この画面の写しを添える」を選んだときだけ）。
// 2026-10-06（#143、docs/53 ★7）：第2条の末尾に「お問い合わせの情報はサポート・開発の担当者に限って確認し、調査・修正が終われば写しは消去する」の1文。
// 2026-10-06（#144、docs/53 §8.4）：第2条5号に「開いていた画面・直前の操作の種類と日時・画面に出たエラーの文（入力した内容は含みません。）」。
// 2026-10-07（#148、docs/58 §10.10 P1）：第2条2項の末尾に「また、サポートの品質向上のため、お問い合わせの内容を利用する場合があります。」。
//   自動の分類・要約は「やり方」なので書かない（第3条3号・4号で目的は覆えている。処理は自社のサーバーの中で委託にも当たらない）。
//   配備した日が 10/7 でなければ、下の updated の改定日をその日に直す
// 2026-11-01（#285 の続き、docs/21）：第2条1項に6号「退会の際のアンケートへの回答（選択式）と任意の自由記述」、第2条に「自由記述は運営担当者が確認する」の項、
//   第10条の括弧書きを「アンケートの選択式の回答の統計的な記録を除く・自由記述は記録に含めず30日で完全に削除」に（射場さんの文のまま）。
//   「前項第6号の自由記述は…」は第2項の終わりの1文に（別の項にすると「前項」が第2項を指して号が無くなるため）。
//   同じ日の夕方（#285 の続き A・B）：第2条2項の末尾に「メールアドレス・電話番号・URL は伏せて保存します。」、第10条の括弧書きに「統計的な記録（2年間保存します）」。改定日は 11/1 のまま
//   配備した日が 11/1 でなければ、下の updated の改定日をその日に直す
// 049（営業力）：製品名と窓口のメールアドレス（support@eigyouryoku.jp）だけ製品で切り替え、条文は共通。
// 名称・窓口は第14条（射場さんの指示で所在地の表示はカット。法の公表事項としては請求に応じて開示＝窓口で対応）。窓口は Email（組み立て式）＋受付時間。代表者名は出さず管理体制で示す（第13条）。公開前に弁護士等の確認を。
const articlesOf = (P: ProductInfo): LegalArticle[] => [
  {
    heading: "第1条（適用範囲）",
    nodes: [
      {
        ol: [
          `本プライバシーポリシー（以下「本ポリシー」といいます。）は、株式会社アイバックス（以下「当社」といいます。）が提供するクラウドサービス「${P.name}」（以下「本サービス」といいます。）における、利用者の個人情報その他の情報の取扱いについて定めるものです。`,
          `本ポリシーに定めのない事項は、法令及び当社が別途定める${P.name}利用規約によります。`,
        ],
      },
    ],
  },
  {
    heading: "第2条（取得する情報）",
    nodes: [
      { p: "当社は、本サービスの提供にあたり、次の情報を取得します。" },
      {
        ol: [
          "利用登録の際にご提供いただく情報：メールアドレス、パスワード（暗号化して保存します。当社は平文のパスワードを保持しません。）",
          "見積書等の発行の際にご入力いただく情報：会社名、住所、電話番号、登録番号（適格請求書発行事業者の登録番号）等",
          "本サービスの利用に伴い利用者が入力・作成する情報（利用者データ）：顧客・案件等の担当者の氏名、電話番号、メールアドレス、住所その他の情報。これらのうち個人情報に該当するものは、暗号化して保存します。",
          "本サービスの利用に伴い当社が自動的に取得する情報：IPアドレス、ブラウザ・端末の種類、アクセス日時、操作ログ、Cookie 等の識別情報",
          "お問い合わせの際にご提供いただく情報：氏名、連絡先、お問い合わせの内容（添付の画像、及び送信の際に選んだときは、お問い合わせを始めたときの画面の写しを含みます。）、並びに不具合の調査のため、お問い合わせを始めたときに開いていた画面、その直前の操作の種類と日時、及び画面に表示されたエラーの文（入力した内容は含みません。）",
          "退会の際にご提供いただく情報：アンケートへの回答（選択式）及び任意でご記入いただく自由記述",
        ],
      },
      {
        p: "前項第5号の情報（添付の画像及び画面の写しを含みます。）は、お問い合わせへの対応並びに不具合の調査及び修正のため、当社のお客様サポート及び開発の担当者に限って確認します。不具合の調査・修正が終わり次第、画面の写しは消去します。また、サポートの品質向上のため、お問い合わせの内容を利用する場合があります。前項第6号の自由記述は、本サービスの改善の参考とするため、当社の運営担当者が確認します。メールアドレス・電話番号・URL は伏せて保存します。",
      },
    ],
  },
  {
    heading: "第3条（利用目的）",
    nodes: [
      { p: "当社は、取得した個人情報を、次の目的の範囲内で利用します。" },
      {
        ol: [
          "本サービスの提供、本人確認及びアカウントの管理のため",
          "有料プランに関する利用料金の請求及び決済のため",
          "お問い合わせ、不具合・障害への対応及び利用者への連絡のため",
          "本サービスの保守、品質の向上、新機能の開発のため（個人を識別できない形に加工した統計的な分析を含みます。）",
          "本サービスに関する重要なお知らせ及び案内の通知のため",
          "利用規約に違反する行為への対応、不正アクセス及び不正利用の防止のため",
          "法令に基づく対応のため",
          "本サービスの改善及び利用者へのご案内のため、画面の表示及び操作の種類・日時（入力した内容は含みません。）を会社ごとに記録し、利用状況の把握に用います。",
        ],
      },
      {
        p: "前項第6号のため、当社は IP アドレスから接続元の国・地域を判定し、日本国外からの利用登録・ログイン・登録情報の変更の際に、登録のメールアドレスへ確認コードを送ることがあります。また、不正な通信に使われているネットワークからの利用登録・ログインをお断りすることがあります。",
      },
      {
        jsx: (
          <p>
            この判定には、DB-IP の「IP to Country Lite」（
            <a href="https://db-ip.com" target="_blank" rel="noopener noreferrer">
              IP Geolocation by DB-IP
            </a>
            、CC BY 4.0）、The Spamhaus Project の DROP リスト及び The Tor Project が公開する出口ノードの一覧を利用します。
          </p>
        ),
      },
    ],
  },
  {
    heading: "第4条（利用者データに含まれる個人情報の取扱い）",
    nodes: [
      {
        ol: [
          "第2条第3号の利用者データに含まれる個人情報は、利用者が自己の事業のために本サービスへ入力するものです。当社は、当該個人情報を、利用者から取扱いの委託を受けたものとして、本サービスの提供に必要な範囲でのみ処理し、利用者の指示又は本ポリシーに定める場合を除き、その内容を利用しません。",
          "利用者は、利用者データに第三者の個人情報を含めて本サービスへ入力する場合、当該個人情報の取得及び取扱いにつき、法令上必要な手続（利用目的の通知・公表、本人の同意の取得等）を、自己の責任において行うものとします。",
        ],
      },
    ],
  },
  {
    heading: "第5条（安全管理措置）",
    nodes: [
      { p: "当社は、取り扱う個人情報の漏えい、滅失又は毀損の防止その他の安全管理のため、次の措置を講じます。" },
      {
        ol: [
          "担当者の氏名・連絡先等の個人情報を、暗号化して保存すること",
          "利用者ごとにデータを分離し、他の利用者のデータにアクセスできない仕組みとすること",
          "通信を暗号化（TLS）すること",
          "個人データを国内のデータセンターに保管すること",
          "個人データを取り扱う従業者及び委託先に対して、必要かつ適切な監督を行うこと",
          "個人データのバックアップを行い、障害からの復旧に備えること",
        ],
      },
    ],
  },
  {
    heading: "第6条（個人データの取扱いの委託）",
    nodes: [
      {
        p: "当社は、利用目的の達成に必要な範囲において、個人データの取扱いの全部又は一部を、国内のクラウドサーバー事業者、メールの送信のためのサーバー事業者その他の委託先に委託することがあります。この場合、当社は、委託先を適切に選定するとともに、委託先に対して必要かつ適切な監督を行います。",
      },
    ],
  },
  {
    heading: "第7条（第三者提供）",
    nodes: [
      {
        ol: [
          {
            text: "当社は、次のいずれかに該当する場合を除き、あらかじめ本人の同意を得ないで、個人データを第三者に提供しません。",
            sub: [
              "法令に基づく場合",
              "人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき",
              "公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき",
              "国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合",
            ],
          },
          "当社は、合併、会社分割、事業譲渡その他の事由により事業の承継が行われる場合、当該事業の承継に伴い、個人データを承継先に提供することがあります。",
          "当社は、外国にある第三者に対して、個人データを提供しません。",
        ],
      },
    ],
  },
  {
    heading: "第8条（Cookie 等の利用及び不正利用の防止）",
    nodes: [
      {
        ol: [
          "本サービスは、ログイン状態の保持その他の利用者の利便性の向上及び本サービスの運用のために、Cookie 等の識別情報を利用します。利用者は、ブラウザの設定により Cookie の受け入れを拒否することができますが、その場合、本サービスの一部が利用できないことがあります。",
          "当社は、不正アクセス及び自動化された手段による不正な利用（大量の自動登録等）を防止するため、アクセスに関する情報を利用し、外部の不正利用防止サービスを利用することがあります。",
        ],
      },
    ],
  },
  {
    heading: "第9条（保有個人データの開示・訂正・利用停止等）",
    nodes: [
      {
        ol: [
          "本人は、当社に対し、当社が保有する当該本人の保有個人データについて、利用目的の通知、開示、内容の訂正・追加・削除、利用の停止・消去及び第三者提供の停止（以下「開示等」といいます。）を請求することができます。",
          "開示等の請求は、第14条のお問い合わせ窓口宛てに、当社所定の方法によりお申し出ください。当社は、ご本人からの請求であることを確認したうえで、法令に従い、遅滞なく対応します。",
          "利用者データに含まれる第三者の個人情報に関する開示等の請求については、原則として、当該情報を入力した利用者において対応いただくものとします。",
        ],
      },
    ],
  },
  {
    heading: "第10条（個人情報の保存期間）",
    nodes: [
      {
        p: "当社は、個人情報を、利用目的の達成に必要な期間又は法令で定められた期間、保有します。利用者が退会した場合、退会の日から30日間は、利用者が退会を取り消せるよう当該個人情報を保持し、30日の経過をもって、登録情報・取引先の情報・作成した書類を含む当該個人情報を削除します（退会の日時及びアンケートの選択式の回答に関する、個人を特定しない統計的な記録（2年間保存します）を除きます。自由記述はこの記録に含めず、退会から30日の経過をもって完全に削除します。）。削除した個人情報は、システムのバックアップに保持期間（おおむね数週間）のあいだ残ることがありますが、その期間の経過をもって消去されます。ただし、法令に基づき保存が必要な場合は、当該期間、保存します。",
      },
    ],
  },
  {
    heading: "第11条（漏えい等が発生した場合の対応）",
    nodes: [
      {
        p: "当社は、個人データの漏えい、滅失若しくは毀損又はそのおそれのある事態が発生した場合には、法令に従い、必要な調査を行うとともに、本人への通知及び個人情報保護委員会への報告その他の必要な措置を講じます。",
      },
    ],
  },
  {
    heading: "第12条（本ポリシーの変更）",
    nodes: [
      {
        p: "当社は、法令の改正又は本サービスの内容の変更等に応じ、本ポリシーを変更することがあります。重要な変更を行う場合には、本サービス上への掲示又は電子メール等の適切な方法により周知します。変更後の本ポリシーは、本サービス上に掲示した時点から効力を生じます。",
      },
    ],
  },
  {
    heading: "第13条（管理体制）",
    nodes: [
      {
        p: "当社は、代表取締役を利用者情報管理責任者とし、利用者情報の適正な管理及び継続的な改善を実施します。",
      },
    ],
  },
  {
    heading: "第14条（事業者情報及びお問い合わせ窓口）",
    nodes: [
      { p: "個人情報の取扱いに関するお問い合わせ及び開示等の請求は、下記の窓口までお願いいたします。" },
      { p: "事業者の名称：株式会社アイバックス" },
      {
        jsx: (
          <>
            <p>個人情報お問い合わせ窓口：<Email user={P.support.user} domain={P.support.domain} /></p>
            <p>受付時間は平日10:00から17:00までとさせていただきます。</p>
          </>
        ),
      },
    ],
  },
];

export function PrivacyPage() {
  const P = useProduct();
  return (
    <LegalDoc
      title={`${P.name} プライバシーポリシー`}
      intro={`株式会社アイバックス（以下「当社」といいます。）は、クラウドサービス「${P.name}」における利用者の個人情報の保護を重要な責務と考え、個人情報の保護に関する法律その他の関係法令を遵守し、次のとおり個人情報を取り扱います。`}
      articles={articlesOf(P)}
      updated="制定日：2026年9月15日／改定日：2026年11月1日"
    />
  );
}
